
import React from 'react'
import { Segment, Container, Divider, Header } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import RequestNoteForm from '../../../notes/form/RequestNote/RequestNoteForm';

interface DetailParams {
    requestReviewId: string;
    requestId: string;
}

const Unlock: React.FC<DetailParams> = ({ requestId, requestReviewId }) => {

    return (
        <Segment clearing>

            <Header>Review Confirmation</Header>
            <Divider />
            <Container>
                Are you sure you want to re-Open this Review?
                    <Divider hidden />
                    This Review will be unlocked from the current reviewer and go back into the request pool.
                    <Divider hidden />
                    If you are sure then please provide a note on why and then submit
            </Container>

            <Divider />

            <RequestNoteForm
                requestId={requestId}
                requestReviewId={requestReviewId}
                note={''}
                noteType={''}
                requestNoteId={''}
            />
        </Segment>
    )
}
export default observer(Unlock);